import React from "react";
import { observer } from "mobx-react";
import { TenantLlmConfigViewStore } from "../../store";
import { TenantLlmConfigViewForm } from "./TenantLlmConfigViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type TenantLlmConfigViewProps = {
  tenantLlmConfigViewStore: TenantLlmConfigViewStore;
};

export const TenantLlmConfigView: React.FC<TenantLlmConfigViewProps> = observer(
  ({ tenantLlmConfigViewStore }) => {
    return (
      <div>
        <TenantLlmConfigViewForm
          providerValue={tenantLlmConfigViewStore.providerValue}
          model={tenantLlmConfigViewStore.modelValue}
          baseUrl={tenantLlmConfigViewStore.baseUrlValue}
          enabled={tenantLlmConfigViewStore.enabledValue}
          priority={tenantLlmConfigViewStore.priorityValue}
          maxTokens={tenantLlmConfigViewStore.maxTokensValue}
          temperature={tenantLlmConfigViewStore.temperatureValue}
          debugFullMode={tenantLlmConfigViewStore.debugFullModeValue}
          onPrint={(handlePrint: () => void) =>
            tenantLlmConfigViewStore.printTenantLlmConfig(handlePrint)
          }
          onCancel={() => tenantLlmConfigViewStore.cancelTenantLlmConfig()}
          onEdit={
            tenantLlmConfigViewStore.isEditEnabled
              ? () => tenantLlmConfigViewStore.editTenantLlmConfig()
              : undefined
          }
        />
        <ErrorDialog
          open={tenantLlmConfigViewStore.errorDialogOpened}
          title={tenantLlmConfigViewStore.errorTitle}
          description={tenantLlmConfigViewStore.errorDescription}
          onClose={() => tenantLlmConfigViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
